import { NewsArticle, WithContext } from 'schema-dts';

import SchemaOrg from '@/components/SchemaOrg';
import { ShortnewsDetailFragment } from '@/components/Shortnews/fragments/__generated__/ShortnewsDetail.generated';

import { defaultImage, publisher } from './constants';

const buildContentPageStructuredData = (shortnewsArticle: ShortnewsDetailFragment, appUrl: string) => {
	const schema: WithContext<NewsArticle> = {
		'@context': 'https://schema.org',
		'@type': 'NewsArticle',
		author: publisher(appUrl),
		dateModified: shortnewsArticle.updateDate,
		datePublished: shortnewsArticle.updateDate,
		description: shortnewsArticle.text ?? undefined,
		headline: shortnewsArticle.title ?? undefined,
		mainEntityOfPage: shortnewsArticle.shareUrl ?? undefined,
		publisher: publisher(appUrl),
		url: shortnewsArticle.shareUrl ?? undefined,
		image: defaultImage(appUrl),
	};

	return (
		<>
			<SchemaOrg schema={schema} />
		</>
	);
};

export default buildContentPageStructuredData;
